import {
  BodyText,
  Button,
  Card,
  Flex,
  Heading,
} from '@utilitywarehouse/hearth-react';
import { useNavigate } from 'react-router-dom';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogID,
  useDialog,
} from '@components/Dialog';
import { paths } from '@constants/paths';
import { ProductIndicator } from '@features/Bundle/BundleTile/ProductIndicator';
import { ProductType } from '@generated/gql/graphql';
import { useBreakpoints } from '@utils/useBreakpoints';

import './styles.scss';

interface WelcomeBonusDialogProps {
  onClose: () => void;
  amount: string;
}

const WelcomeBonusDialog = ({ onClose, amount }: WelcomeBonusDialogProps) => {
  const dialog = useDialog(DialogID.WELCOME_BONUS);
  const navigate = useNavigate();

  const handleClose = () => {
    dialog.setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  const handleConfirm = () => {
    dialog.setOpen(false);
    navigate(paths.cashback);
  };
  const { breakpointsDown } = useBreakpoints();
  const isMobile = breakpointsDown.sm;

  return (
    <Dialog
      id={DialogID.WELCOME_BONUS}
      className="welcomeDialog"
      heading={`Add Cashback Card to get your £${amount} welcome bonus`}
      hideCloseButton={isMobile}
    >
      <DialogContent>
        <BodyText color="secondary" marginBottom="300">
          The Cashback Card is where we'll put your welcome bonus. Add it so you
          don't miss out!
        </BodyText>
        <Card className="bundle-tile__wrapper" variant="emphasis" paddingNone>
          <ProductIndicator productType={ProductType.CashbackCard} />
          <Flex direction="column" className="bundle-tile__content">
            <Heading as="h3" size="lg" marginBottom="150">
              Cashback Card
            </Heading>
            <div>
              <BodyText size="md" color="secondary">
                Earn up to 15% cashback every time you use your card online and
                in-store
              </BodyText>
            </div>
            <div />
          </Flex>
        </Card>
      </DialogContent>
      <DialogActions>
        <Button
          variant="ghost"
          data-testid="welcome-dialog-skip"
          onClick={handleClose}
        >
          Skip for now
        </Button>
        <Button
          variant="solid"
          data-testid="welcome-dialog-confirm"
          onClick={handleConfirm}
        >
          Find out more
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { WelcomeBonusDialog, type WelcomeBonusDialogProps };
